import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import OtpInput from "react-otp-input";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  getAuth,
  resendOtp,
  resetResendOtp,
  resetVerifyOtp,
  userReauthenticate,
  verifyOtp,
} from "../../redux/slices/authSlice";
import "pure-react-carousel/dist/react-carousel.es.css";
import { getUserToken } from "../../libs/user";
import LoadingSpinner from "../../components/Loader";

const Reauthenticate = ({ screenType = "web" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [otpErr, setOtpErr] = useState("");
  const [message_id, setMessageId] = useState("");
  const [counter, setCounter] = useState(0);

  const [sendOTPSuccess, setSendOTPSuccess] = useState(false);
  const [otp, setOtp] = useState("");

  const token = getUserToken();
  const NUMBER = /^[0-9]*$/;

  const INPUT_STYLE = {
    margin: "10px",
    fontSize: "17px",
    borderRadius: 4,
    border: "1px solid #6F719B",
    color: "#fff",
    width: "56px",
    height: "56px",
    border: "1px solid #9498B5",
    borderRadius: "8px",
  };
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const { loader } = useSelector((state) => state.app);
  const fingerprint = useSelector((state) => state.fingerprint);
  const phone = useSelector(
    (state) => state.auth.user?.data?.user?.mobile_number
  );

  const {
    formState: { errors },
  } = useForm();

  const { referee = "" } = location.state || {};

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = function () {
      window.history.pushState(null, "", window.location.href);
    };
    if (!referee) {
      navigate("/accounts", { replace: true });
    }
    return () => {
      window.history.replaceState({}, null, window.location.href);
    };
  }, []);

  const handleVerifyOtp = (isValid = false, otpValue = "") => {
    if (isValidForm() || (isValid && otpValue.length === 6)) {
      dispatch(
        verifyOtp({
          otp: isValid ? otpValue : otp,
          phone,
          message_id,
          fingerprint,
        })
      )
        .unwrap()
        .then((response) => {
          if (response?.success) {
            navigate(referee, { replace: true });
          }
        })
        .catch((error) => {
          setOtpErr(error?.error?.message);
        });
    }
  };

  const handleResendOTP = () => {
    dispatch(
      resendOtp({
        phone,
        message_id,
      })
    )
      .unwrap()
      .then((response) => {
        setSendOTPSuccess(true);
      })
      .catch((error) => {
        setSendOTPSuccess(false);
        console.log(error);
      });
    dispatch(resetResendOtp());
  };

  const handleOtpChange = (value) => {
    if (NUMBER.test(Number(value))) {
      setOtp(value);
      if (value?.length === 6) {
        handleVerifyOtp(true, value);
      }
    }
  };

  useEffect(() => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter]);

  const isValidForm = () => {
    if (!otp || otp.length !== 6) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (sendOTPSuccess) {
      setCounter(60);
    }
  }, [sendOTPSuccess]);

  // useEffect(() => {
  //   dispatch(getRecaptcha({ action: "signup" }));
  // }, [dispatch]);

  useEffect(() => {
    dispatch(userReauthenticate({ login_type: "OTP", token, phone }))
      .unwrap()
      .then((response) => {
        if (response?.success) {
          setMessageId(response.message_id);
          setCounter(60);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return () => {
      dispatch(resetVerifyOtp());
      dispatch(resetResendOtp());
    };
  }, []);

  const handleContinue = (e) => {
    if (otp.length === 6) {
      handleVerifyOtp();
    }
    if (!otp) {
      setOtpErr("Please enter 6 digit code");
    }
  };

  const handleCancel = () => {
    navigate("/accounts", { replace: true });
  };
  return (
    <>
      <div className="containtLndPg login-pg-container">
        {/* login content starts*/}
        <div className="center-container">
          <div className="center-container-box container1">
            <h2 className={`verifyHeader`}>Reauthenticate your account</h2>
            <div className={`verifyTextContainer`}>
              <span className={`codeText`}>
                We sent a 6 digit code to {phone}.
              </span>

              <span className={`codeText1`}>Please enter it below.</span>
            </div>
            <div className="login-form login">
              <div className="field-box">
                <div className={`otpInput`}>
                  <OtpInput
                    shouldAutoFocus={true}
                    numInputs={6}
                    value={otp}
                    onChange={handleOtpChange}
                    inputStyle={`input_style`}
                    className={`formGroupOtp`}
                    renderInput={(props) => (
                      <input {...props} type="number" inputMode="numeric" />
                    )}
                  />

                  <span className="errMsg">{otpErr}</span>
                  {auth.resendOtp?.error?.error?.message &&
                    !errors.otp &&
                    !otpErr && (
                      <span className="errMsg">
                        {auth.resendOtp?.error?.error?.message}
                      </span>
                    )}
                </div>
              </div>
            </div>
            {sendOTPSuccess && counter !== 0 && (
              <div className={`resendContainer`}>
                <span className={`resendOTPtext`}>New Code Sent!</span>
              </div>
            )}
            {auth.resendOtp?.error?.error?.code === 5029 ? (
              ""
            ) : (
              <>
                {counter !== 0 ? (
                  <div className="mobileInputText">{`Resend code in ${counter}s`}</div>
                ) : (
                  <div className={`sendCode`}>
                    <a onClick={handleResendOTP}>{"Send Code Again ->"}</a>
                  </div>
                )}
              </>
            )}
            <div className="authenticateBtn">
              <button
                className="continueButton"
                onClick={(e) => handleContinue(e)}
              >
                Continue
              </button>
              <button className="cancelButton" onClick={() => handleCancel()}>
                Cancel
              </button>
            </div>
          </div>
        </div>
        {loader && <LoadingSpinner />}
      </div>
    </>
  );
};
export default Reauthenticate;
